import {Component, Input, OnInit} from '@angular/core';
import moment from "moment";
import 'moment/locale/fr'
import {calculDiffDays} from "../../utils/utils.functions";
moment.locale('fr');
@Component({
  selector: 'app-date-cell',
  templateUrl: './date-cell.component.html',
  styleUrl: './date-cell.component.scss'
})
export class DateCellComponent implements OnInit {
  @Input() startDate: string;
  @Input() endDate: string;
  days : number = 0


  constructor() {}
  ngOnInit(): void {
    // To display the final no. of days (result)
    this.days = calculDiffDays(this.startDate, this.endDate)

  }

  protected readonly moment = moment;
}
